import { render, staticRenderFns } from "./NetworkIcon.vue?vue&type=template&id=3b875b8a&scoped=true&"
import script from "./NetworkIcon.vue?vue&type=script&lang=js&"
export * from "./NetworkIcon.vue?vue&type=script&lang=js&"
import style0 from "./NetworkIcon.vue?vue&type=style&index=0&id=3b875b8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b875b8a",
  null
  
)

export default component.exports